import { FiChevronLeft } from "react-icons/fi";
import { useNavigation } from "../hooks/useNavigation";
import { useRouteScrollContainer } from "../hooks/useRouteScrollContainer";

interface ScreenContainerProps {
    children: React.ReactNode;
    title: string;
    className?: string;
    headerAction?: React.ReactNode;
}

const ScreenContainer: React.FC<ScreenContainerProps> = ({ children, title, className, headerAction }) => {
    const { goBack } = useNavigation();
    const setRouteScrollContainer = useRouteScrollContainer<HTMLDivElement>(`screen:${title}`);

    return (
        <div className={`fixed top-0 left-0 right-0 h-full w-screen flex flex-col bg-background text-foreground ${className}`}>
            {/* Header Bar */}
            <header className="flex-shrink-0 px-4 py-2.5">
                <div className="mx-auto w-full max-w-sm flex flex-row items-center justify-between">
                    <button
                        className="p-2 rounded-full hover:bg-muted transition-colors"
                        onClick={goBack}>
                        <FiChevronLeft size={24} />
                    </button>
                    <h1 className="text-lg font-semibold">{title}</h1>
                    <div className="min-w-[42px] flex items-center justify-end">
                        {headerAction ?? <div className="w-[42px]" />} {/* Spacer */}
                    </div>
                </div>
            </header>

            <div
                ref={setRouteScrollContainer}
                className="flex-grow h-full overflow-y-auto bg-background text-foreground"
            >
                {children}
            </div>
        </div>
    );
};

export default ScreenContainer;
